import PropTypes from 'prop-types';
import React from 'react';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import DeleteUgcForm from 'app/components/bibs/shared/ugc/DeleteUgcForm';
import ModalContainer from 'app/components/shared/Modal/ModalContainer';

export default function DeleteSummaryModal({
  summaryId,
  catalogBib,
  summariesActions,
  handleSuccess,
  modalActions,
  isLoading
}) {
  function handleClose() {
    modalActions.closeModal(`delete-summary-${summaryId}`);
  }

  return (
    <ModalContainer
      className="cp-delete-summary-modal"
      modalKey={`delete-summary-${summaryId}`}
      size="small"
      handleClose={handleClose}
    >
      <DeleteUgcForm
        ugcType="summary"
        id={summaryId}
        catalogBib={catalogBib}
        removeUgcAction={summariesActions.removeSummary}
        isLoading={isLoading}
        handleClose={handleClose}
        handleSuccess={handleSuccess}
      />
    </ModalContainer>
  );
}

DeleteSummaryModal.propTypes = {
  summaryId: PropTypes.number.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleSuccess: PropTypes.func,
  summariesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isLoading: PropTypes.bool.isRequired,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};
